import dayjs, {Dayjs} from 'dayjs';

export const DATE_SERVER_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_SERVER_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
export const DATE_TIME_UI_FORMAT = 'DD.MM.YYYY HH:mm';

export const DATE_MASK_NO_SEPARATOR_FORMAT = 'DDMMYYYY';
const DATE_MASK_WITH_SLASH_FORMAT = 'DD/MM/YYYY';

export const DATE_UI_FORMAT = 'DD.MM.YYYY';
export const MONTH_YEAR_UI_FORMAT = 'MM.YYYY';
export const SHORT_DATE_UI_FORMAT = 'DD.MM.YY';
const DATE_TIME_WITH_SECONDS_UI_FORMAT = 'DD.MM.YYYY HH:mm:ss';

export function formatFromServerToNoSeparatorMask(date: string): string {
    return formatFromServerToMask(date, DATE_MASK_NO_SEPARATOR_FORMAT);
}

export function formatFromServerToMaskWithSlash(date: string): string {
    return formatFromServerToMask(date, DATE_MASK_WITH_SLASH_FORMAT);
}

export function formatFromServerToMask(date: string, mask: string): string {
    if (date && dayjs(date).isValid()) {
        return dayjs(date).format(mask);
    } else {
        return null;
    }
}

export function formatFromNoSeparatorMaskToServer(date: dayjs.ConfigType): string {
    return formatFromMaskToServer(date, DATE_MASK_NO_SEPARATOR_FORMAT);
}

export function formatFromMaskWithSlashToServer(date: dayjs.ConfigType): string {
    return formatFromMaskToServer(date, DATE_MASK_WITH_SLASH_FORMAT);
}

export function formatFromMaskToServer(date: dayjs.ConfigType, format: string): string {
    if (date && dayjs(date, format, true).isValid()) {
        return dayjs(date, format, true).format(DATE_SERVER_FORMAT);
    } else {
        return null;
    }
}

export function formatDateTimeFromDateToUi(date: Date): string {
    return dayjs(date).format(DATE_TIME_UI_FORMAT);
}

export function formatDateFromDateToUi(date: Date): string {
    return dayjs(date).format(DATE_UI_FORMAT);
}

export function formatDateFromDateToUiShort(date: Date): string {
    return dayjs(date).format(SHORT_DATE_UI_FORMAT);
}

export function formatToServer(date: dayjs.ConfigType): string {
    if (date && dayjs(date).isValid()) {
        return dayjs(date).format(DATE_SERVER_FORMAT);
    } else {
        return null;
    }
}

export function formatFromServerToUi(date: dayjs.ConfigType): string {
    return dayjs(date, DATE_SERVER_FORMAT).format(DATE_UI_FORMAT);
}

export function dateFromMask(date: dayjs.ConfigType): Dayjs {
    return dayjs(date, DATE_MASK_NO_SEPARATOR_FORMAT, true);
}

export function formatDateTimeFromServerToUi(date: dayjs.ConfigType): string {
    return dayjs(date, DATE_TIME_SERVER_FORMAT).format(DATE_TIME_WITH_SECONDS_UI_FORMAT);
}

export function getFormattedDateOrNull(date?: Date, dateFormat: string = DATE_TIME_SERVER_FORMAT): string {
    return date && dayjs(date).format(dateFormat);
}

export function startOfDay(date: Date = new Date()): Date {
    const result = new Date(date);
    result.setHours(0, 0, 0, 0);
    return result;
}

export function endOfDay(date: Date = new Date()): Date {
    const result = new Date(date);
    result.setHours(23, 59, 59, 999);
    return result;
}

export function applyTime(date: Date, time?: string): Date {
    if (!time) {
        return new Date(date);
    }
    const [hours, minutes] = time.split(':').map(Number);
    const result = new Date(date);
    result.setHours(hours, minutes);
    return result;
}
